<script setup>
    import { reactive } from 'vue'
    import { notify } from '@kyvg/vue3-notification'
    import { useChannelsStore } from '@/stores/channels'
    import { executeLogin, initLogin, loadSDK } from '@/composables/useFacebookLogin'

    import AlertPrice from '@/views/dash/channels/Pages/AlertPrice.vue'
    import InputFormHorizontal from '@/components/UI/Form/InputFormHorizontal.vue'
    import StoryActiveAutomation from '@/views/dash/channels/Pages/StoryActiveAutomation.vue'

    const state = reactive({ textButton: '' })
    const store = useChannelsStore()
    store.formStep = 2

    store.channel.name = store.channel?.name || ''
    store.channel.type = 'messenger'
    store.channel.server_type = 'messenger'

    store.channel.user =
        store.channel?.user || Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

    loadSDK(document, 'script', 'facebook-jssdk')
    const appId = import.meta.env.VITE_MESSENGER_ID
    initLogin(appId)

    function loginMessenger(response) {
        if (response.status !== 'connected') {
            notify({
                type: 'error',
                title: 'Opps...',
                text: 'Não foi possível realizar o login. Por favor, tente realizar o login no Facebook novamente!',
            })
            return
        }

        console.warn(response)

        state.textButton = 'Login realizado!'
        store.channel.api_token = response.authResponse.accessToken
    }

    state.textButton = (store.channel?.id ? 'Atualizar' : 'Cadastrar') + ' Messenger'

    const scope = [
        // Messenger
        'public_profile',
        'pages_messaging',
        'pages_manage_metadata',
        'business_management',

        // Pages (comments)
        'pages_read_engagement',
        'pages_manage_engagement',
        'pages_manage_posts',
        'pages_show_list',
    ]

    function handleToggle(newValue, key) {
        store.channel.more[key] = newValue
    }
</script>

<template>
    <div class="space-y-4">
        <InputFormHorizontal
            v-model="store.channel.name"
            :init-value="store.channel.name"
            :block-edit="store.loading"
            label="Identificação do canal"
            placeholder="Como você irá locallizar o canal pelo sistema?"
            rules="required"
            vertical
        />

        <div>
            <button
                class="flex justify-center bg-gradient-to-r from-blue-500 to-cyan-600 text-white text-sm font-bold py-2 px-4 rounded-full chat_transition"
                :class="{ 'opacity-50 cursor-not-allowed': store.loading || store.channel.name.length === 0 }"
                :disabled="store.loading || store.channel.name.length === 0"
                @click.prevent.stop="executeLogin(loginMessenger, scope)"
            >
                <Unicon name="facebook-messenger" class="h-5 w-5 mr-2" />
                {{ state.textButton }}
            </button>
            <small class="dark:text-gray-300 opacity-50 ml-4">Realizar login no Facebook</small>
        </div>

        <AlertPrice />

        <StoryActiveAutomation v-if="store.channel?.id && false" />
    </div>
</template>
